var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEssentia21AnosEng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_essentia_21_anos_BR",
    xmlns: "http://www.w3.org/2000/svg",
    width: 425.2,
    height: 425.2,
    viewBox: "0 0 425.2 425.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1",
    "data-name": "Ret\\xE2ngulo 1",
    width: 425.2,
    height: 425.2,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(1142.77 -43.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8",
    transform: "translate(-871.681 110.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_40",
    "data-name": "Caminho 40",
    d: "M-370.813,228.546-349,206.731l-18.077-18.057-7.264,7.264-3.751-3.751,7.274-7.271-7.274-7.274,3.751-3.751,7.28,7.281,10.8-10.793-10.8-10.8-7.274,7.271-3.741-3.741,11.022-11.022,16.826,16.826v22.044l-9.549-9.549-3.522,3.522,18.057,18.067V166.846l-21.822-21.815-18.057,18.077,7.264,7.264-3.751,3.751-7.274-7.274-7.271,7.274-3.751-3.751,7.28-7.28-10.793-10.8-10.8,10.8,7.274,7.274-3.741,3.741-11.022-11.022,16.826-16.826h22.044l-9.549,9.549,3.522,3.523L-370.8,141.28H-406.95L-428.765,163.1l18.077,18.057,7.264-7.264,3.751,3.751-7.274,7.274,7.274,7.274-3.751,3.751-7.28-7.28-10.8,10.793,10.8,10.8,7.271-7.271,3.741,3.741-11.022,11.022-16.826-16.826V178.883l9.549,9.549,3.522-3.523-18.057-18.067V202.99L-410.7,224.8l18.057-18.077-7.264-7.264,3.751-3.751,7.271,7.274,7.274-7.274,3.751,3.751-7.281,7.281,10.793,10.8,10.8-10.8-7.274-7.274,3.741-3.741,11.022,11.022-16.826,16.826h-22.044l9.549-9.549L-388.9,210.5l-18.06,18.054h36.144Zm3.748-61.929,3.758,3.758-3.751,3.751-3.758-3.758Zm-40.111-3.523,3.758-3.758,3.751,3.751-3.758,3.758Zm-3.523,40.111-3.758-3.758,3.751-3.751,3.758,3.758Zm21.818-29.318,3.751,3.751-3.751,3.751-3.751-3.751Zm-7.274,14.773-3.751-3.751,3.751-3.751,3.751,3.751Zm7.274,7.274-3.751-3.751,3.751-3.751,3.751,3.751Zm3.523-11.022,3.751-3.751,3.751,3.751-3.751,3.751Zm14.77,21.815-3.758,3.758-3.751-3.751,3.758-3.758,3.751,3.751Z",
    transform: "translate(442.799 -130.998)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M-355.679,141.863l-31.583-31.583h-44.665l-31.583,31.583v44.665l31.583,31.583h44.665l31.583-31.583Zm-4.982,42.6-28.664,28.664h-40.535l-28.664-28.664V143.926l28.664-28.664h40.535l28.664,28.664Z",
    transform: "translate(463.51 -110.28)",
    fill: "#b1965e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M-966.613,801.288l-9.437-1.018,1.018-9.44,9.443,1.015-1.025,9.44Zm-6.743-3.188,4.574.494.494-4.577-4.581-.494-.491,4.577Z",
    transform: "translate(-65.633 -454.822)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(-1074.257 115.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M-1050.066,693.46l-4.514-12.442,3.217-1.168,3.154,8.7,3.821-1.386-3.088-8.514,3.217-1.167,3.088,8.514,4.086-1.483-3.154-8.7,3.244-1.174,4.511,12.441Z",
    transform: "translate(1061.107 -493.072)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M-1052.558,631.674a8.2,8.2,0,0,0,1.323-6.322c-.425-2.146-1.648-2.992-2.693-2.783-1.377.272-1.529,1.96-1.605,4.176-.1,3.134-.159,7.148-4.259,7.961-3.055.6-6.053-1.549-6.906-5.868a10.4,10.4,0,0,1,1.144-7.659l3.29,1.609a7.976,7.976,0,0,0-.968,5.652c.348,1.761,1.3,2.544,2.4,2.325,1.237-.245,1.32-1.861,1.4-4.076.089-3.161.235-7.194,4.309-8,3.357-.663,6.362,1.231,7.34,6.183a10.779,10.779,0,0,1-1.376,8.362l-3.4-1.559Z",
    transform: "translate(1069.376 -455.596)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M-1060.712,570.559a8.21,8.21,0,0,0,2.282-6.043c-.09-2.186-1.168-3.207-2.232-3.164-1.4.056-1.811,1.7-2.229,3.881-.577,3.081-1.257,7.038-5.433,7.208-3.111.126-5.741-2.461-5.921-6.859a10.4,10.4,0,0,1,2.309-7.39l3.005,2.1a7.962,7.962,0,0,0-1.828,5.436c.073,1.794.9,2.713,2.016,2.67,1.261-.05,1.589-1.635,2.007-3.814.574-3.111,1.34-7.072,5.486-7.241,3.42-.139,6.1,2.2,6.3,7.237a10.787,10.787,0,0,1-2.647,8.05l-3.115-2.063Z",
    transform: "translate(1074.257 -414.674)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M-1073.12,507.261l1.5-13.151,3.4.388-1.045,9.194,4.04.458,1.025-9,3.4.385-1.025,9,4.319.491,1.045-9.194,3.426.388-1.5,13.151-18.584-2.113Z",
    transform: "translate(1073.497 -372.421)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M-1056.7,433.154l12.07,3.486-1.1,3.824-17.971-5.191,1.138-3.934,14.044-4.962-11.639-3.363,1.1-3.824,17.971,5.191-1.065,3.692-14.544,5.081Z",
    transform: "translate(1067.208 -322.351)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M-1034.971,365.263l-2.371,4.929-3.158-1.519,6.471-13.443,3.158,1.519-2.358,4.9,13.7,6.594-1.738,3.612-13.7-6.594Z",
    transform: "translate(1051.696 -279.606)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M-1008.57,328.177l2.143-3.357,15.772,10.057-2.143,3.357Z",
    transform: "translate(1030.357 -259.282)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_50",
    "data-name": "Caminho 50",
    d: "M-960.5,286.917l-5.36,6.411,1.722,2.972-2.806,3.357-9.712-17.546,3.2-3.831,18.972,6.465-2.786,3.337Zm-7.324,3.383,3.974-4.756-8.564-3.134,4.587,7.891Z",
    transform: "translate(1009.031 -228.179)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_51",
    "data-name": "Caminho 51",
    d: "M-895.849,201.5a8.766,8.766,0,0,1,8.687-1.1l-1.675,3.37a5.311,5.311,0,0,0-4.979.62,5.824,5.824,0,0,0-1.264,8.395,5.826,5.826,0,0,0,8.329,1.655,6.318,6.318,0,0,0,2.481-3.493l-1.307-1.857-4.086,2.869-1.967-2.8,7.3-5.128,4.11,5.851a10.382,10.382,0,0,1-4.484,7.47c-4.474,3.144-10.339,2.6-13.725-2.216-3.4-4.843-1.891-10.5,2.584-13.642Z",
    transform: "translate(957.993 -175.671)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M-831.616,177.707l-2.64,1.241,2.852,6.063-3.6,1.695-7.964-16.923,7.917-3.725c3.526-1.658,6.77-.365,8.252,2.78a5.367,5.367,0,0,1-1.34,6.766l6.839,4.654-4.136,1.947-6.179-4.5Zm-2.511-8.3-3.781,1.778,2.2,4.667,3.781-1.778a2.583,2.583,0,0,0,1.44-3.529,2.583,2.583,0,0,0-3.635-1.141Z",
    transform: "translate(919.684 -152.695)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M-766.032,141.346a9.4,9.4,0,0,1,11.97,6.786,9.4,9.4,0,0,1-6.925,11.891,9.392,9.392,0,0,1-11.944-6.8,9.39,9.39,0,0,1,6.9-11.884Zm.922,3.41c-3.33.9-4.78,4.02-3.868,7.407.906,3.357,3.741,5.35,7.068,4.451s4.8-4.056,3.894-7.413c-.915-3.383-3.768-5.343-7.1-4.445Z",
    transform: "translate(873.129 -136.404)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M-696.507,128.547l4.023-.318.879,11.072c.206,2.6,1.774,4.275,4.68,4.043,2.852-.226,4.136-2.129,3.93-4.727l-.879-11.068,4.027-.318.886,11.181c.368,4.64-2.036,8.01-7.685,8.458-5.7.451-8.611-2.524-8.975-7.108l-.889-11.211Z",
    transform: "translate(821.803 -127.23)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M-620.975,127.76l8.713.8c4.05.371,6,3.314,5.7,6.581-.3,3.241-2.783,5.741-6.8,5.373l-4.746-.438-.614,6.674-3.967-.365Zm7.868,4.159-4.216-.388-.474,5.138,4.216.388a2.546,2.546,0,0,0,2.972-2.318,2.562,2.562,0,0,0-2.5-2.819Z",
    transform: "translate(772.468 -127.584)",
    fill: "#b1965e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10",
    transform: "translate(55.96 142.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_56",
    "data-name": "Caminho 56",
    d: "M-893.57,885.719l.182,2.1-3.579.226-.176-2.3a10.538,10.538,0,0,1-4.179-1.828,9.39,9.39,0,0,1-2.282-13.553,9.393,9.393,0,0,1,13.573-2.166,9.4,9.4,0,0,1,2.305,13.569A9.656,9.656,0,0,1-893.57,885.719Zm-3.9-3.8-.275-3.27,3.566-.2.275,3.271a6.7,6.7,0,0,0,2.852-2.335c2.047-2.846,1.761-6.3-1.042-8.309s-6.139-1.164-8.186,1.685c-2.03,2.826-1.784,6.282,1.018,8.292a5.6,5.6,0,0,0,1.791.872Z",
    transform: "translate(905.541 -763.935)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M-832.752,897.933l3.659,1.711L-833.8,909.7c-1.1,2.362-.571,4.594,2.07,5.831,2.591,1.214,4.647.2,5.755-2.169l4.71-10.057,3.658,1.715-4.756,10.16c-1.974,4.216-5.731,5.957-10.863,3.552-5.181-2.428-6.239-6.451-4.285-10.617l4.77-10.186Z",
    transform: "translate(860.69 -785.127)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M-766.724,945.717l-8.057-2.216-1.99,2.8-4.219-1.161,11.937-16.117,4.813,1.323,1.99,19.948-4.193-1.154-.279-3.423Zm-6.116-5.26,5.977,1.645-.7-9.091-5.277,7.45Z",
    transform: "translate(822.302 -805.905)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M-700.247,940.38l3.957.448-1.708,15.1,7.861.889-.395,3.483-11.818-1.337,2.1-18.588Z",
    transform: "translate(769.746 -813.497)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M-642.5,944.637l3.984-.007.027,18.7-3.98.007Z",
    transform: "translate(729.747 -816.337)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M-607.622,943.73l-5.43.667-.428-3.479,14.81-1.818.428,3.479-5.4.663,1.851,15.088-3.98.488Z",
    transform: "translate(710.352 -812.642)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M-548.963,935.849l-9.987-8.62,4.365-1.261,6.557,5.931,2.335-8.5,4.365-1.26-3.808,12.6,2.123,7.357-3.828,1.1-2.123-7.357Z",
    transform: "translate(673.909 -801.307)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M-457.732,894.021l-11.788-5.927,3.927-2.285,7.8,4.156.2-8.81,3.927-2.285-.624,13.148,3.851,6.617-3.443,2-3.851-6.617Z",
    transform: "translate(614.142 -772.389)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M-401.13,850.344a9.4,9.4,0,0,1,13.715,1.138,9.4,9.4,0,0,1-1.3,13.7,9.391,9.391,0,0,1-13.7-1.158A9.388,9.388,0,0,1-401.13,850.344Zm2.269,2.71c-2.643,2.212-2.654,5.659-.4,8.345,2.232,2.667,5.642,3.287,8.285,1.075s2.657-5.7.424-8.365C-392.8,851.422-396.214,850.838-398.861,853.054Z",
    transform: "translate(570.88 -751.691)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M-359.55,799.369l2.561-3.121,8.584,7.045c2.017,1.655,4.312,1.688,6.159-.567,1.814-2.212,1.337-4.455-.68-6.11l-8.584-7.045,2.564-3.121,8.67,7.118c3.6,2.952,4.358,7.022.763,11.4-3.629,4.421-7.791,4.451-11.347,1.532l-8.69-7.135Z",
    transform: "translate(540.647 -710.623)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M-300.98,734l1.708-3.6,13.732,6.521,3.393-7.144,3.168,1.506-5.1,10.74-16.9-8.023Z",
    transform: "translate(501.504 -672.75)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_67",
    "data-name": "Caminho 67",
    d: "M-279.54,685.678l1.294-3.768,17.692,6.07-1.294,3.768Z",
    transform: "translate(487.175 -640.758)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_68",
    "data-name": "Caminho 68",
    d: "M-270.467,630.215l.906-4.451,15.131-2.216-13.068-7.927.906-4.451,16.893,10.793-1,4.892-19.775,3.36Z",
    transform: "translate(481.114 -593.481)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_69",
    "data-name": "Caminho 69",
    d: "M-257.99,571.068l.5-13.228,3.42.129-.352,9.247,4.063.156.345-9.052,3.42.129-.345,9.052,4.342.166.352-9.247,3.446.133-.5,13.228Z",
    transform: "translate(472.773 -557.84)",
    fill: "#b1965e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_70",
    "data-name": "Caminho 70",
    d: "M-562.6,448.486l.242-1.141a57.3,57.3,0,0,0,.7-8.083l3.672-71.481h-2.836L-583.32,384.3l1.26,2.09,13.861-8.7.219-.139h1.443l-.043.942-2.64,56.313c-.166,4.531-1.154,8.053-2.935,10.455-1.718,2.319-4.488,3.645-8.246,3.95l-.066,2.189H-552.5l.156-3.4-9.091.431-1.164.056Z",
    transform: "translate(-328.101 -172.091)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12",
    transform: "translate(-974.912 296.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_71",
    "data-name": "Caminho 71",
    d: "M-764.325,671.293l.156.2a106.784,106.784,0,0,1,1.6,15.41h.08a37.422,37.422,0,0,0,3.98-9.795,25.085,25.085,0,0,0,.391-4.955,10.245,10.245,0,0,1,3.784-.9c.312,0,.743,1.055.743,2.03,0,1.443-1.874,5.032-4.02,8.544-2.262,3.668-4.488,7.609-5.227,8.856-3.005,4.955-4.76,7.881-8.624,7.881-2.066,0-3.277-1.091-3.277-2.226,0-1.366,1.131-2.886,2.418-2.886.624-.04.779.04,1.4.9a2.744,2.744,0,0,0,1.874,1.327c.663,0,1.6-.743,1.99-2.146a13.6,13.6,0,0,0,.312-4.136c-.235-4.1-1.211-9.951-1.718-12.916-.236-1.718-.74-2.262-1.562-2.3l-2.106.04-.04-1.171,7.841-1.755Z",
    transform: "translate(774.74 -671.25)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_72",
    "data-name": "Caminho 72",
    d: "M-692.76,684.285c-2.654,4.683-6.126,5.891-9.6,5.891-2.73,0-5.931-1.211-5.931-6.282a13.943,13.943,0,0,1,2.926-8.468,10.551,10.551,0,0,1,8.428-4.176c3.277,0,5.032,1.718,5.032,4.176,0,5.111-8,6.478-11.238,6.829-.04.352,0,1.131,0,1.443,0,2.03.743,4.02,2.965,4.02,2.342,0,4.368-1.794,6.163-4.408l1.247.975Zm-3.317-9.483c0-1.055-.507-1.794-1.522-1.794-2.342,0-4.916,3.513-5.347,7.649,4.332-.819,6.866-3.081,6.866-5.851Z",
    transform: "translate(730.331 -671.25)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_73",
    "data-name": "Caminho 73",
    d: "M-635.064,671.565l-3.7,13.891c-.236,1.015-.312,1.755.352,1.755.819,0,2.3-2.186,3.042-3.668l1.211.819c-1.483,3.005-3.629,5.814-6.982,5.814-2.262,0-3.121-1.522-2.226-4.527l.935-3.161h-.076c-1.99,3.549-5,7.685-9.208,7.685-2.769,0-3.629-2.146-3.629-4.564,0-4.839,4.057-14.359,12.8-14.359a5.507,5.507,0,0,1,2.73.663l.08-.352h4.683Zm-7.217,1.483c-4.488,0-7.765,8.388-7.765,12.213,0,1.287.272,1.95,1.131,1.95,2.418,0,6.634-7.725,7.649-10.77.391-1.091.7-2.066.9-2.809a2.875,2.875,0,0,0-1.911-.584Z",
    transform: "translate(694.95 -671.25)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_74",
    "data-name": "Caminho 74",
    d: "M-585.01,690.136l2.925-12.6c.779-3.277.584-3.669-.2-3.745l-2.146-.236.312-1.211,7.453-1.055.235.156-1.639,6.67h.2c1.91-3.7,4.332-6.866,6.634-6.866a1.965,1.965,0,0,1,2.106,2.226c0,1.406-1.367,3.2-2.5,3.2-1.367,0-1.327-1.091-2.378-1.091-1.131,0-2.965,3.784-4.136,7.178-.859,2.537-1.367,4.408-2.066,6.945l-4.8.428Z",
    transform: "translate(647.941 -671.25)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_75",
    "data-name": "Caminho 75",
    d: "M-524.026,674.62a2.38,2.38,0,0,1-2.3,2.106,1.493,1.493,0,0,1-1.443-.975c-.975-1.834-1.638-2.693-2.73-2.693a1.644,1.644,0,0,0-1.678,1.834c0,1.055.819,2.03,2.965,3.864,2.03,1.718,3.473,3.045,3.473,5.463,0,3.237-2.73,5.97-7.373,5.97s-6.126-2.066-6.126-3.705a2.609,2.609,0,0,1,2.342-2.5,1.45,1.45,0,0,1,1.522.975c1.211,2.5,2.226,3.433,3.393,3.433a1.805,1.805,0,0,0,1.874-1.95c0-1.247-1.055-2.614-2.809-4.1-1.443-1.247-3.277-2.73-3.277-5.227,0-3.317,2.5-5.851,6.829-5.851s5.347,2.186,5.347,3.357Z",
    transform: "translate(617.352 -671.263)",
    fill: "#b3965f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_76",
    "data-name": "Caminho 76",
    d: "M-725.342,372.785c-4.338-3.32-10.027-5.005-16.909-5.005a31.729,31.729,0,0,0-13.36,2.66,22.839,22.839,0,0,0-8.78,6.647,12.823,12.823,0,0,0-3,7.688,5,5,0,0,0,1.367,3.668,4.472,4.472,0,0,0,3.373,1.4,4.438,4.438,0,0,0,3.423-1.383,4.671,4.671,0,0,0,1.317-3.323,6.257,6.257,0,0,0-1.555-4.514l-.4-.428.229-.541a13.871,13.871,0,0,1,5.95-6.508,17.914,17.914,0,0,1,9.277-2.511c5.579,0,9.609,1.864,11.974,5.542,2.292,3.566,3.33,8.239,3.081,13.888-.169,3.887-1.811,8.236-4.886,12.922a72.286,72.286,0,0,1-11.844,13.592l-.01.01-.01.01-4.2,3.579c-4.756,4.1-8.528,7.592-11.214,10.378a39.615,39.615,0,0,0-6.743,9.566A29.7,29.7,0,0,0-771.28,451.4h50.061l1.5-14.664h-1.887c-.328,3.2-1.619,5.413-3.834,6.577-2.269,1.194-5.605,1.775-10.2,1.775-3.131,0-5.605-.04-7.36-.119l-20.863-.6-1.108-.033.259-1.078c.833-3.476,3.045-7.164,6.574-10.962a111.948,111.948,0,0,1,14.276-12.451c15.622-12.02,23.818-22.6,24.359-31.431.381-7.118-1.579-12.382-5.828-15.636Z",
    transform: "translate(-202.484 -172.091)",
    fill: "#b3965f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEssentia21AnosEng);
export default __webpack_public_path__ + "static/media/logo_essentia_21_anos_ENG.e2c344e7adb3077f2c6114361fbc595b.svg";
export { ForwardRef as ReactComponent };